import { useSettings } from '../../hooks';
import { useWhiteLabelGoogleTag } from '../useWhiteLabelGoogleTag/useWhiteLabelGoogleTag';

import { Products } from './types';

export const usePolicyStreamGoogleAnalytics = () => {
  const {
    settings: { googleAnalyticsToken },
  } = useSettings();
  return useWhiteLabelGoogleTag(googleAnalyticsToken, {
    product: Products.Life,
  });
};
